import { useEffect } from "react";
import Lenis from "@studio-freight/lenis";
import "@/App.css";
import Profile from "@/pages/Profile";
import { Toaster } from "@/components/ui/sonner";

function App() {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    // Stop smooth scroll during printing so pagination is accurate
    const before = () => lenis.stop();
    const after = () => lenis.start();
    window.addEventListener("beforeprint", before);
    window.addEventListener("afterprint", after);

    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.removeEventListener("beforeprint", before);
      window.removeEventListener("afterprint", after);
    };
  }, []);

  return (
    <div className="App bg-hauz-bg text-hauz-primary">
      <div className="noise-overlay" aria-hidden="true" />
      <Profile />
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

export default App;
